import { render, staticRenderFns } from "./DateTimeLanguageConfig.vue?vue&type=template&id=09f45418&scoped=true"
import script from "./DateTimeLanguageConfig.vue?vue&type=script&lang=js"
export * from "./DateTimeLanguageConfig.vue?vue&type=script&lang=js"
import style0 from "./DateTimeLanguageConfig.vue?vue&type=style&index=0&id=09f45418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f45418",
  null
  
)

export default component.exports